import React from 'react'
import ReactDOM from 'react-dom'
import ThemeContext from '../../../site/layout/component/Theme/ThemeContext'
import OfferCarousel from '../../../site/layout/component/OfferCarousel'

const debug = require('debug')('offerCarousel')

export default () => {
  debug('init')
  document.addEventListener('DOMContentLoaded', () => {
    const theme = document.querySelector('body').dataset.theme

    document.querySelectorAll('.js-offer-carousel').forEach(appNode => {
      const props = JSON.parse(appNode.getAttribute('data-props') || '{}')
      ReactDOM.render(
        <ThemeContext.Provider value={theme}>
          <OfferCarousel {...props} />
        </ThemeContext.Provider>,
        appNode
      )
    })
  })
}
